import { Box, Heading, Stack, useTheme } from "@chakra-ui/react";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../../components/BackButton";
import HybridBottomSheetDrawer from "../../components/HybridBottomSheetDrawer";
import OutletCard from "../../components/outlets/OutletCard";
import PCRoomCard from "../../components/pcs/PCRoomCard";
import QueryStateWrapper from "../../components/QueryStateWrapper";
import { usePCs } from "../../data/pcs.api";
import { useFocusOnPoints } from "../../hooks/useFocusOnPoints";

const AllOutlets = () => {
  const { data, isLoading, error } = usePCs();
  const navigate = useNavigate();
  const theme = useTheme();

  const points = useMemo(() => {
    if (data) {
      return data.Groups.filter(
        (pcRoom) => pcRoom.Longitude && pcRoom.Latitude
      ).map((pcRoom) => ({
        lat: pcRoom.Latitude,
        lng: pcRoom.Longitude,
        onClick: () => navigate(`/pcs/${pcRoom.PlanOnId}`),
        color: pcRoom.Available
          ? theme?.colors?.["green"]?.["500"]
          : theme?.colors?.["lancsRed"]?.["300"],
      }));
    }
    return [];
  }, [data, navigate, theme?.colors]);

  useFocusOnPoints(points);

  return (
    <HybridBottomSheetDrawer>
      <BackButton />

      <Box p={8}>
        <Heading size="md" mb={4}>
          PC Availability
        </Heading>
        <QueryStateWrapper isLoading={isLoading} error={error} data={data}>
          <Stack>
            {data?.Groups.map((pcRoom) => (
              <PCRoomCard pcRoom={pcRoom} />
            ))}
          </Stack>
        </QueryStateWrapper>
      </Box>
    </HybridBottomSheetDrawer>
  );
};

export default AllOutlets;
